// src/components/shops/postTemplates/Ticket.tsx
//
// A torn stub: the offer above the perforation, the terms below it.
//
// The shape is doing the work. A discount written in a normal card is a
// sentence to scroll past; the same words on something that looks redeemable
// get screenshotted, which is exactly what a shop wants — and it rhymes with
// the punch cards the app already runs.

import { cachedUrl } from '../../../lib/storageUrl'
import SocialBrewBadge from '../SocialBrewBadge'
import { categoryLabel, bodyLines, type TemplateProps } from './types'

export default function Ticket({
  title, body, photos, category, shopName, rating, ratingCount, scale = 1,
}: TemplateProps) {
  const px = (n: number) => `${n * scale}px`
  const label = categoryLabel(category) || 'Offer'
  const lines = bodyLines(body)
  // The first line carries the offer, the rest read as the small print.
  const [lead, ...terms] = lines

  return (
    <div
      className="overflow-hidden"
      style={{ background: '#fdf8ee', borderRadius: px(6), border: '1px solid #e8d8c0' }}
      data-shop={shopName}
    >
      {photos.length > 0 && (
        <div style={{ aspectRatio: '16 / 9' }}>
          <img src={cachedUrl(photos[0])} alt="" loading="lazy" className="w-full h-full object-cover" />
        </div>
      )}

      {/* ── Stub top: what you get ── */}
      <div style={{ padding: `${px(18)} ${px(18)} ${px(16)}`, textAlign: 'center' }}>
        <p
          style={{
            fontSize: px(9),
            letterSpacing: '0.3em',
            textTransform: 'uppercase',
            color: '#c8853a',
            fontWeight: 700,
            marginBottom: px(10),
          }}
        >
          {label}
        </p>
        <h3
          className="font-display"
          style={{
            fontSize: px(25),
            lineHeight: 1.1,
            color: '#241810',
            margin: 0,
            fontWeight: 700,
            letterSpacing: '-0.015em',
            textWrap: 'balance',
          }}
        >
          {title}
        </h3>
        {lead && (
          <p style={{ fontSize: px(13), lineHeight: 1.5, color: '#6e5038', marginTop: px(8) }}>
            {lead}
          </p>
        )}
      </div>

      {/* ── Perforation ──
          Drawn as a dashed rule rather than punched notches: notches have to be
          filled with whatever sits behind the card, and this card is shown on a
          shop page, in a preview and on an export ground that are all different
          colours. A dashed line reads as a tear on every one of them. */}
      <div
        style={{
          borderTop: `${px(1.5)} dashed #dcc9ab`,
          margin: `0 ${px(12)}`,
        }}
      />

      {/* ── Stub bottom: the small print ── */}
      <div style={{ padding: `${px(12)} ${px(18)} ${px(14)}`, background: '#f8efe0' }}>
        {terms.length > 0 ? (
          terms.map((line, i) => (
            <p
              key={i}
              style={{
                fontSize: px(10.5),
                lineHeight: 1.6,
                color: '#8c6a48',
                margin: 0,
                letterSpacing: '0.01em',
              }}
            >
              {line}
            </p>
          ))
        ) : (
          <p style={{ fontSize: px(10.5), lineHeight: 1.6, color: '#8c6a48', margin: 0 }}>
            Show this post at the counter.
          </p>
        )}

        <div style={{ marginTop: px(12) }}>
          <SocialBrewBadge rating={rating} ratingCount={ratingCount} tone="light" scale={scale} />
        </div>
      </div>
    </div>
  )
}
